export var DepositTagType;
(function (DepositTagType) {
    DepositTagType["RMB"] = "rmb";
    DepositTagType["CRYPTO"] = "crypto";
    DepositTagType["RECOMMENDED"] = "recommended";
    DepositTagType["LAST_USED"] = "last_used";
    DepositTagType["WALLET"] = "wallet";
})(DepositTagType || (DepositTagType = {}));
//# sourceMappingURL=DepositTagType.js.map